import { useEffect, useState } from 'react'
import Graytextarea from '../../../components/Graytextarea'
import Editor, { Toolbar } from 'react-simple-wysiwyg';

const MedsRecordsFreetype = ({ patientDBdata, patientID, loggedUserProvider, setPatientDBdata ,noteActualId}) => {

const [medHtml, setMedHtml] = useState("")
    const [medId, setMedId] = useState(null)
    const [medication, setMedication] = useState({})

    useEffect(() => {
        const metadataId = patientDBdata?.currentNote?.data.metadata?.medId
        setMedId(metadataId || null)
        if (metadataId) {
            const findMedication = patientDBdata?.allMedications?.find((item) => item.id === Number(metadataId))
            setMedication(findMedication || {})
        }
    }, [patientDBdata, patientID])

useEffect(() => {
    if (!medId || !medication?.data?.length) return

    const html = `
        <div>
            <div style=";">
                ${medication.data
                    .map(
                        (item) => `
                    <div style="">
            <div style=""><strong>${item.name}</strong> ${item.dosage ?? ''} ${item.route ?? ''} ${item.frequency ?? ''}</div>
                    </div>
                `
                    )
                    .join("")}
            </div>
        </div>
    `

    const savedFreeTypes = patientDBdata?.currentNote?.data?.freeTypesEverything?.medHtml
    if(!savedFreeTypes){
                setPatientDBdata((prev) => {
            return {
                ...prev,
                currentNote: {
                    ...prev?.currentNote,
                    data: {
                        ...prev?.currentNote?.data,
                        freeTypesEverything: {
                            ...prev?.currentNote?.data?.freeTypesEverything,
                            medHtml: html
                        }
                    },
                },


                allNotes: prev?.allNotes?.map((note) => {
                    if (note?.id === noteActualId) {
                        const parsedData = note?.data ? JSON.parse(note.data) : {}

                        return {
                            ...note,
                            data: JSON.stringify({
                                ...parsedData,
                                freeTypesEverything: {
                                    ...parsedData?.freeTypesEverything,
                                    medHtml: html
                                }
                            }),
                        }
                    }
                    return note
                }),
            }
        })
    }

    setMedHtml(savedFreeTypes || html)
}, [medication, medId])

useEffect(() => {
  if (!medId || !medication?.data?.length) return

  const generatedHtml = `
    <div>
      ${medication.data
        .map(
          (item) => `
        <div>
          <strong>${item.name}</strong>
          ${item.dosage ?? ''} ${item.route ?? ''} ${item.frequency ?? ''}
        </div>
      `
        )
        .join('')}
    </div>
  `

  const savedFreeType =
    patientDBdata?.currentNote?.data?.freeTypesEverything?.medHtml

  const initialHtml = savedFreeType || generatedHtml
  setMedHtml(initialHtml)

  if (!savedFreeType) {
    setPatientDBdata((prev) => ({
      ...prev,
      currentNote: {
        ...prev.currentNote,
        data: {
          ...prev.currentNote.data,
          freeTypesEverything: {
            ...prev.currentNote.data?.freeTypesEverything,
            medHtml: initialHtml,
          },
        },
      },
    }))
  }
}, [medication, medId])


    const handleChange = (index, field, value) => {
        setMedication((prev) => ({
            ...prev,
            data: prev.data.map((item, i) =>
                i === index
                    ? { ...item, [field]: value }
                    : item
            ),
        }))
    }

    const handleBlur = async () => {
        setPatientDBdata((prev) => {
            return {
                ...prev,
                currentNote: {
                    ...prev?.currentNote,
                    data: {
                        ...prev?.currentNote?.data,
                        freeTypesEverything: {
                            ...prev?.currentNote?.data?.freeTypesEverything,
                            medHtml: medHtml
                        }
                    },
                },


                allNotes: prev?.allNotes?.map((note) => {
                    if (note?.id === noteActualId) {
                        const parsedData = note?.data ? JSON.parse(note.data) : {}

                        return {
                            ...note,
                            data: JSON.stringify({
                                ...parsedData,
                                freeTypesEverything: {
                                    ...parsedData?.freeTypesEverything,
                                    medHtml: medHtml
                                }
                            }),
                        }
                    }
                    return note
                }),
            }
        })
    }


    if(!medId){
        return null
    }


    
    return (
        <div className='d-flex  '>
            <div style={{ width: "30%" }}>Medications</div>
            <div className='w-100'>
                <Editor
                value={medHtml}
                onChange={(e) => setMedHtml(e.target.value)}
                onBlur={handleBlur}
                containerProps={{
                        style: {
                            width: "100%",
                            background: "#2D2D2D",
                            color: "white",
                            border: 0,
                        }
                    }}
                >
                    <Toolbar hidden />
                </Editor>
            </div>
        </div>
    )
}

export default MedsRecordsFreetype

